import { PreloadAllModules, RouterModule } from "@angular/router";
import { NgModule } from "@angular/core";
import { DashboardComponent } from "./screens/dashboard/dashboard.component";
import { AppMainComponent } from "./app.main.component";
import { LoginComponent } from "./screens/login/login.component";
import { TokenGuard } from "./core/services/token.guard";
import { MyDataComponent } from "./screens/my-data/my-data.component";
import { UsersComponent } from "./screens/users/users.component";
import { ServicesComponent } from "./screens/services/services.component";
import { LocationStrategy, PathLocationStrategy } from "@angular/common";
import { NotificationsComponent } from "./screens/notifications/notifications.component";
import { SendNotificationsComponent } from "./screens/send-notifications/send-notifications.component";
import { AvisoLegalComponent } from "./screens/avisolegal/avisolegal.component";
import { CalendarServicesComponent } from "./screens/calendar-services/calendar-services.component";
import { HousingComponent } from "./screens/housing/housing.component";
import { ExtrasComponent } from "./screens/extras/extras.component";
import { CalendarServicesListComponent } from "./screens/calendar-services-list/calendar-services-list.component";
import { UsersLogsComponent } from "./screens/users-logs/users-logs.component";
import { GoogleCalendarComponent } from "./screens/google-calendar/google-calendar.component";

@NgModule({
	imports: [
		RouterModule.forRoot(
			[
				{ 
					path: "login", 
					component: LoginComponent
				},
				{ 
					path: "aviso-legal", 
					component: AvisoLegalComponent
				},
				{
					path: "app",
					component: AppMainComponent,
					canActivate: [TokenGuard],
					children: [
						{
							path: "",
							component: DashboardComponent,
							canActivate: [TokenGuard],
						},
						{
							path: "my-data",
							component: MyDataComponent,
							canActivate: [TokenGuard],
						},
						{
							path: "usersWorker",
							component: UsersComponent,
							canActivate: [TokenGuard],
						},
						{
							path: "usersBilling",
							component: UsersComponent,
							canActivate: [TokenGuard],
						},
						{
							path: "users",
							component: UsersComponent,
							canActivate: [TokenGuard],
						},
						{
							path: "users-logs",
							component: UsersLogsComponent,
							canActivate: [TokenGuard],
						},
						{
							path: "google-calendar",
							component: GoogleCalendarComponent,
							canActivate: [TokenGuard],
						},
						{
							path: "services",
							component: ServicesComponent,
							canActivate: [TokenGuard],
						},
						{
							path: "extras",
							component: ExtrasComponent,
							canActivate: [TokenGuard],
						},
						{
							path: "housing",
							component: HousingComponent,
							canActivate: [TokenGuard],
						},
						{
							path: "send-notifications",
							component: SendNotificationsComponent,
							canActivate: [TokenGuard],
						},
						{
							path: "notifications",
							component: NotificationsComponent,
							canActivate: [TokenGuard],
						},
						{
							path: "services-calendar",
							component: CalendarServicesComponent,
							canActivate: [TokenGuard],
						},
						{
							path: "services-calendar-list",
							component: CalendarServicesListComponent,
							canActivate: [TokenGuard],
						}
					],
				},
				{ 
					path: "**", 
					redirectTo: "login", 
					pathMatch: "full"
				},
			],
			{ preloadingStrategy: PreloadAllModules, useHash: true }
		),
	],
	exports: [RouterModule],
	providers: [{ provide: LocationStrategy, useClass: PathLocationStrategy }],
})
export class AppRoutingModule {}
